import React from "react"

// ui components
import Paper from "components/UI/elements/Paper"

import accessImageUrl from "images/access.png"
import "./NotAuthorizedPage.css"

const NotAuthorizedPage = () => (
  <Paper className="not-authorized">
    <img src={accessImageUrl} alt="Not Authorized" className="left-side" />
    <div className="right-side">
      <h1>You don't have permission to view that page.</h1>
      <h2>Contact your administrator</h2>
    </div>
  </Paper>
)

export default NotAuthorizedPage
